export const ISQ_DEFINITION = {
    name: "SI",
    defaultSystem: "metric",
    prefixes: [
        {
            name: "yotta",
            symbol: "Y",
            exponent: 24,
        },
        {
            name: "zetta",
            symbol: "Z",
            exponent: 21,
        },
        {
            name: "exa",
            symbol: "E",
            exponent: 18,
        },
        {
            name: "peta",
            symbol: "P",
            exponent: 15,
        },
        {
            name: "tera",
            symbol: "T",
            exponent: 12,
        },
        {
            name: "giga",
            symbol: "G",
            exponent: 9,
        },
        {
            name: "mega",
            symbol: "M",
            exponent: 6,
        },
        {
            name: "kilo",
            symbol: "K",
            exponent: 3,
        },
        {
            name: "hecto",
            symbol: "h",
            exponent: 2,
        },
        {
            name: "deca",
            symbol: "da",
            exponent: 1,
        },
        {
            name: "none",
            symbol: "",
            exponent: 0,
        },
        {
            name: "deci",
            symbol: "d",
            exponent: -1,
        },
        {
            name: "centi",
            symbol: "c",
            exponent: -2,
        },
        {
            name: "milli",
            symbol: "m",
            exponent: -3,
        },
        {
            name: "micro",
            symbol: "µ",
            exponent: -6,
        },
        {
            name: "nano",
            symbol: "n",
            exponent: -9,
        },
        {
            name: "pico",
            symbol: "p",
            exponent: -12,
        },
        {
            name: "femto",
            symbol: "f",
            exponent: -15,
        },
        {
            name: "atto",
            symbol: "a",
            exponent: -18,
        },
        {
            name: "zepto",
            symbol: "z",
            exponent: -21,
        },
        {
            name: "yocto",
            symbol: "y",
            exponent: -24,
        },
    ],
    quantities: [
        {
            name: "mass",
            symbol: "m",
            dimension: "M",
            defaultUnit: {
                prefix: "kilo",
                name: "gram",
                symbol: "g",
            },
            units: [
                {
                    prefix: "none",
                },
                {
                    name: "tonne",
                    symbol: "t",
                    numerator: 1000.0,
                },
                {
                    system: "imperial",
                    name: "pound",
                    symbol: "lb",
                    numerator: 0.45359237,
                },
                {
                    name: "grain",
                    symbol: "gr",
                    parent: "mass.imperial.pound",
                    denominator: 7000.0,
                },
                {
                    name: "drachm",
                    symbol: "dr",
                    parent: "mass.imperial.pound",
                    denominator: 256.0,
                },
                {
                    name: "ounce",
                    symbol: "oz",
                    parent: "mass.imperial.pound",
                    denominator: 16.0,
                },
                {
                    name: "stone",
                    symbol: "st",
                    parent: "mass.imperial.pound",
                    numerator: 14.0,
                },
                {
                    name: "quarter",
                    symbol: "qr",
                    parent: "mass.imperial.pound",
                    numerator: 28.0,
                },
                {
                    name: "hunderdweight",
                    symbol: "cwt",
                    parent: "mass.imperial.pound",
                    numerator: 112.0,
                },
                {
                    name: "ton",
                    symbol: "t",
                    parent: "mass.imperial.pound",
                    numerator: 2240.0,
                },
                {
                    name: "slug",
                    symbol: "slug",
                    parent: "mass.imperial.pound",
                    numerator: 32.17404856,
                },
                {
                    system: "us",
                    name: "hunderdweight",
                    symbol: "cwt",
                    parent: "mass.imperial.pound",
                    numerator: 100.0,
                },
                {
                    system: "us",
                    name: "ton",
                    symbol: "t",
                    parent: "mass.imperial.pound",
                    numerator: 2000.0,
                },
            ],
        },
        {
            name: "length",
            symbol: "l",
            dimension: "L",
            defaultUnit: {
                name: "metre",
                symbol: "m",
            },
            units: [
                {
                    system: "imperial",
                    name: "yard",
                    symbol: "yd",
                    numerator: 0.9144,
                },
                {
                    name: "thou",
                    symbol: "th",
                    parent: "length.imperial.yard",
                    denominator: 36000.0,
                },
                {
                    name: "inch",
                    symbol: "in",
                    parent: "length.imperial.yard",
                    denominator: 36.0,
                },
                {
                    name: "foot",
                    symbol: "ft",
                    parent: "length.imperial.yard",
                    denominator: 3.0,
                },
                {
                    name: "chain",
                    symbol: "ch",
                    parent: "length.imperial.yard",
                    numerator: 22.0,
                },
                {
                    name: "furlong",
                    symbol: "fur",
                    parent: "length.imperial.yard",
                    numerator: 220.0,
                },
                {
                    name: "mile",
                    symbol: "mi",
                    parent: "length.imperial.yard",
                    numerator: 5280.0,
                    denominator: 3.0,
                },
                {
                    name: "league",
                    symbol: "lea",
                    parent: "length.imperial.yard",
                    numerator: 15340.0,
                    denominator: 3.0,
                },
                {
                    name: "link",
                    symbol: "li",
                    parent: "length.imperial.yard",
                    numerator: 22.0,
                    denominator: 100.0,
                },
                {
                    name: "rod",
                    symbol: "rd",
                    parent: "length.imperial.yard",
                    numerator: 11.0,
                    denominator: 2.0,
                },
                {
                    system: "us",
                    name: "foot",
                    symbol: "ft",
                    numerator: 1200.0,
                    denominator: 3937.0,
                },
                {
                    name: "link",
                    symbol: "li",
                    parent: "length.us.foot",
                    numerator: 33.0,
                    denominator: 50.0,
                },
                {
                    name: "rod",
                    symbol: "rd",
                    parent: "length.us.foot",
                    numerator: 33.0,
                    denominator: 2.0,
                },
                {
                    name: "chain",
                    symbol: "ch",
                    parent: "length.us.foot",
                    numerator: 66.0,
                },
                {
                    name: "furlong",
                    symbol: "fur",
                    parent: "length.us.foot",
                    numerator: 660.0,
                },
                {
                    name: "mile",
                    symbol: "mi",
                    parent: "length.us.foot",
                    numerator: 5280.0,
                },
                {
                    name: "league",
                    symbol: "lea",
                    parent: "length.us.foot",
                    numerator: 15840.0,
                },
                {
                    system: "nautical",
                    name: "fathom",
                    symbol: "ftm",
                    parent: "length.imperial.yard",
                    numerator: 2.0,
                },
                {
                    system: "nautical",
                    name: "cable",
                    symbol: "cb",
                    parent: "length.imperial.yard",
                    numerator: 240.0,
                },
                {
                    system: "nautical",
                    name: "mile",
                    symbol: "nmi",
                    numerator: 1852.0,
                },
            ],
        },
        {
            name: "time",
            symbol: "t",
            dimension: "T",
            defaultUnit: {
                name: "second",
                symbol: "s",
            },
            units: [
                {
                    name: "minute",
                    symbol: "min",
                    numerator: 60.0,
                },
                {
                    name: "hour",
                    symbol: "h",
                    numerator: 3600.0,
                },
                {
                    name: "day",
                    symbol: "d",
                    numerator: 86400.0,
                },
            ],
        },
        {
            name: "electricCurrent",
            symbol: "I",
            dimension: "I",
            defaultUnit: {
                name: "ampere",
                symbol: "A",
            },
        },
        {
            name: "thermodynamicTemperature",
            symbol: "T",
            dimension: "Θ",
            defaultUnit: {
                name: "kelvin",
                symbol: "K",
            },
            units: [
                {
                    name: "celsius",
                    symbol: "°C",
                    offsetNumerator: 273.15,
                },
                {
                    system: "other",
                    name: "fahrenheit",
                    symbol: "°F",
                    numerator: 5.0,
                    denominator: 9.0,
                    offsetNumerator: 2298.35,
                    offsetDenominator: 9.0,
                },
                {
                    system: "other",
                    name: "rankine",
                    symbol: "°R",
                    numerator: 5.0,
                    denominator: 9.0,
                },
            ],
        },
        {
            name: "amountOfSubstance",
            symbol: "n",
            dimension: "N",
            defaultUnit: {
                name: "mole",
                symbol: "mol",
            },
        },
        {
            name: "luminousIntensity",
            symbol: "L",
            dimension: "J",
            defaultUnit: {
                name: "candela",
                symbol: "cd",
            },
        },
        {
            name: "angle",
            symbol: "∠",
            defaultUnit: {
                name: "radian",
                symbol: "㎭",
            },
            baseQuantities: [
                {
                    name: "length",
                    dimension: 0,
                },
            ],
            units: [
                {
                    name: "degree",
                    symbol: "°",
                    numerator: 3.141592653589793,
                    denominator: 180.0,
                },
                {
                    name: "turn",
                    symbol: "turns",
                    numerator: 3.141592653589793,
                    denominator: 0.5,
                },
                {
                    name: "gon",
                    symbol: "ᶢ",
                    numerator: 3.141592653589793,
                    denominator: 200.0,
                },
            ],
        },
        {
            name: "area",
            symbol: "A",
            baseQuantities: [
                {
                    name: "length",
                    dimension: 2,
                },
            ],
            units: [
                {
                    baseUnits: [
                        {
                            name: "length.metric.kilo.metre",
                            dimension: 2,
                        },
                    ],
                },
                {
                    name: "are",
                    symbol: "a",
                    numerator: 100.0,
                },
                {
                    prefix: "hecto",
                    parent: "area.metric.are",
                },
                {
                    system: "imperial",
                    name: "perch",
                    symbol: "perch",
                    numerator: 30.25,
                    baseUnits: [
                        {
                            name: "length.imperial.yard",
                            dimension: 2,
                        },
                    ],
                },
                {
                    system: "imperial",
                    name: "rood",
                    symbol: "rood",
                    numerator: 1210.0,
                    baseUnits: [
                        {
                            name: "length.imperial.yard",
                            dimension: 2,
                        },
                    ],
                },
                {
                    system: "imperial",
                    name: "acre",
                    symbol: "acre",
                    numerator: 4840.0,
                    baseUnits: [
                        {
                            name: "length.imperial.yard",
                            dimension: 2,
                        },
                    ],
                },
            ],
        },
        {
            name: "volume",
            symbol: "V",
            baseQuantities: [
                {
                    name: "length",
                    dimension: 3,
                },
            ],
            units: [
                {
                    name: "litre",
                    symbol: "L",
                    denominator: 1000.0,
                },
                {
                    system: "imperial",
                    name: "gallon",
                    symbol: "gal",
                    parent: "volume.metric.litre",
                    numerator: 4.54609,
                },
                {
                    name: "quarter",
                    symbol: "qt",
                    parent: "volume.imperial.gallon",
                    denominator: 4.0,
                },
                {
                    name: "pint",
                    symbol: "pt",
                    parent: "volume.imperial.gallon",
                    denominator: 8.0,
                },
                {
                    name: "gill",
                    symbol: "gi",
                    parent: "volume.imperial.gallon",
                    denominator: 32.0,
                },
                {
                    name: "fluidOunce",
                    symbol: "fl oz",
                    parent: "volume.imperial.gallon",
                    denominator: 160.0,
                },
                {
                    system: "us",
                    name: "liquidGallon",
                    symbol: "gal",
                    parent: "volume.metric.litre",
                    numerator: 3.785411784,
                },
                {
                    name: "minim",
                    symbol: "min",
                    parent: "volume.us.liquidGallon",
                    denominator: 61440.0,
                },
                {
                    name: "liquidDram",
                    symbol: "fl dr",
                    parent: "volume.us.liquidGallon",
                    denominator: 1024.0,
                },
                {
                    name: "teaspoon",
                    symbol: "tsp",
                    parent: "volume.us.liquidGallon",
                    denominator: 768.0,
                },
                {
                    name: "tablespoon",
                    symbol: "tbsp",
                    parent: "volume.us.liquidGallon",
                    denominator: 256.0,
                },
                {
                    name: "fluidOunce",
                    symbol: "fl oz",
                    parent: "volume.us.liquidGallon",
                    denominator: 128.0,
                },
                {
                    name: "shot",
                    symbol: "jig",
                    parent: "volume.us.liquidGallon",
                    numerator: 3.0,
                    denominator: 256.0,
                },
                {
                    name: "gill",
                    symbol: "gi",
                    parent: "volume.us.liquidGallon",
                    denominator: 32.0,
                },
                {
                    name: "cup",
                    symbol: "cp",
                    parent: "volume.us.liquidGallon",
                    denominator: 16.0,
                },
                {
                    name: "liquidPint",
                    symbol: "pt",
                    parent: "volume.us.liquidGallon",
                    denominator: 8.0,
                },
                {
                    name: "liquidQuart",
                    symbol: "qt",
                    parent: "volume.us.liquidGallon",
                    denominator: 4.0,
                },
                {
                    name: "liquidBarrel",
                    symbol: "bbl",
                    parent: "volume.us.liquidGallon",
                    numerator: 63.0,
                    denominator: 2.0,
                },
                {
                    name: "oilBarrel",
                    symbol: "bbl",
                    parent: "volume.us.liquidGallon",
                    numerator: 42.0,
                },
                {
                    name: "hogshead",
                    symbol: "hogshead",
                    parent: "volume.us.liquidGallon",
                    numerator: 63.0,
                },
                {
                    system: "us",
                    name: "dryGallon",
                    symbol: "gal",
                    numerator: 268.8025,
                    baseUnits: [
                        {
                            name: "length.imperial.inch",
                            dimension: 3,
                        },
                    ],
                },
                {
                    name: "dryPint",
                    symbol: "pt",
                    parent: "volume.us.dryGallon",
                    denominator: 8.0,
                },
                {
                    name: "dryQuart",
                    symbol: "qt",
                    parent: "volume.us.dryGallon",
                    denominator: 4.0,
                },
                {
                    name: "peck",
                    symbol: "pk",
                    parent: "volume.us.dryGallon",
                    numerator: 2.0,
                },
                {
                    name: "bushel",
                    symbol: "bu",
                    parent: "volume.us.dryGallon",
                    numerator: 8.0,
                },
                {
                    system: "us",
                    name: "dryBarrel",
                    symbol: "bbl",
                    numerator: 7056.0,
                    baseUnits: [
                        {
                            name: "length.imperial.inch",
                            dimension: 3,
                        },
                    ],
                },
            ],
        },
        {
            name: "velocity",
            symbol: "v→",
            baseQuantities: [
                {
                    name: "length",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: -1,
                },
            ],
            units: [
                {
                    baseUnits: [
                        {
                            name: "length.metric.kilo.metre",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
                {
                    baseUnits: [
                        {
                            name: "length.metric.milli.metre",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
                {
                    baseUnits: [
                        {
                            name: "length.imperial.mile",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
        {
            name: "acceleration",
            symbol: "a→",
            baseQuantities: [
                {
                    name: "velocity",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "standardGravity",
                    symbol: "g₀",
                    numerator: 9.80665,
                },
            ],
        },
        {
            name: "precipitation",
            symbol: "ppt",
            baseQuantities: [
                {
                    name: "length",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "mmph",
                    baseUnits: [
                        {
                            name: "length.metric.milli.metre",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
        {
            name: "force",
            symbol: "F→",
            baseQuantities: [
                {
                    name: "mass",
                    dimension: 1,
                },
                {
                    name: "acceleration",
                    dimension: 1,
                },
            ],
            units: [
                {
                    name: "newton",
                    symbol: "N",
                },
                {
                    system: "imperial",
                    name: "poundsOfForce",
                    symbol: "lbf",
                    baseUnits: [
                        {
                            name: "mass.imperial.pound",
                            dimension: 1,
                        },
                        {
                            name: "acceleration.metric.standardGravity",
                            dimension: 1,
                        },
                    ],
                },
                {
                    name: "kilogramsOfForce",
                    symbol: "kp",
                    baseUnits: [
                        {
                            name: "mass.metric.kilo.gram",
                            dimension: 1,
                        },
                        {
                            name: "acceleration.metric.standardGravity",
                            dimension: 1,
                        },
                    ],
                },
            ],
        },
        {
            name: "pressure",
            symbol: "p",
            baseQuantities: [
                {
                    name: "force",
                    dimension: 1,
                },
                {
                    name: "area",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "pascal",
                    symbol: "Pa",
                },
                {
                    prefix: "hecto",
                    parent: "pressure.metric.pascal",
                },
                {
                    name: "mmhg",
                    symbol: "mmHg",
                    parent: "pressure.metric.pascal",
                    numerator: 101325.0,
                    denominator: 760.0,
                },
                {
                    system: "imperial",
                    name: "psi",
                    symbol: "psi",
                    baseUnits: [
                        {
                            name: "force.imperial.poundsOfForce",
                            dimension: 1,
                        },
                        {
                            name: "length.imperial.inch",
                            dimension: -2,
                        },
                    ],
                },
                {
                    name: "referenceSoundPressure",
                    symbol: "p₀",
                    numerator: 2.0,
                    denominator: 100000.0,
                },
            ],
        },
        {
            name: "energy",
            symbol: "E",
            baseQuantities: [
                {
                    name: "force",
                    dimension: 1,
                },
                {
                    name: "length",
                    dimension: 1,
                },
            ],
            units: [
                {
                    name: "joule",
                    symbol: "J",
                },
            ],
        },
        {
            name: "power",
            symbol: "P",
            baseQuantities: [
                {
                    name: "energy",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "watt",
                    symbol: "W",
                },
                {
                    prefix: "mega",
                    parent: "power.metric.watt",
                },
                {
                    name: "referenceSoundPower",
                    symbol: "P₀",
                    denominator: 1000000000000.0,
                },
                {
                    name: "adjustedSoundLevel",
                    symbol: "BA",
                    prefix: "deci",
                    base: 10.0,
                    parent: "power.metric.referenceSoundPower",
                },
            ],
        },
        {
            name: "electricCharge",
            symbol: "Q",
            baseQuantities: [
                {
                    name: "electricCurrent",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: 1,
                },
            ],
            units: [
                {
                    name: "coulomb",
                    symbol: "C",
                },
            ],
        },
        {
            name: "electricPotential",
            symbol: "V",
            baseQuantities: [
                {
                    name: "energy",
                    dimension: 1,
                },
                {
                    name: "electricCharge",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "volt",
                    symbol: "V",
                },
            ],
        },
        {
            name: "electricCapacitance",
            symbol: "C",
            baseQuantities: [
                {
                    name: "electricCharge",
                    dimension: 1,
                },
                {
                    name: "electricPotential",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "farad",
                    symbol: "F",
                },
            ],
        },
        {
            name: "electricResistance",
            symbol: "R",
            baseQuantities: [
                {
                    name: "electricPotential",
                    dimension: 1,
                },
                {
                    name: "electricCurrent",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "ohm",
                    symbol: "Ω",
                },
                {
                    prefix: "kilo",
                    name: "ohm",
                    symbol: "Ω",
                },
            ],
        },
        {
            name: "soundIntensity",
            symbol: "I",
            baseQuantities: [
                {
                    name: "power",
                    dimension: 1,
                },
                {
                    name: "area",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "referenceSoundIntensity",
                    symbol: "I₀",
                    denominator: 1000000000000.0,
                },
            ],
        },
        {
            name: "irradiance",
            symbol: "Ee",
            baseQuantities: [
                {
                    name: "power",
                    dimension: 1,
                },
                {
                    name: "area",
                    dimension: -1,
                },
            ],
            units: [
                {
                    baseUnits: [
                        {
                            name: "power.metric.watt",
                            dimension: 1,
                        },
                        {
                            name: "length.metric.metre",
                            dimension: -2,
                        },
                    ],
                },
                {
                    baseUnits: [
                        {
                            name: "power.metric.kilo.watt",
                            dimension: 1,
                        },
                        {
                            name: "length.metric.metre",
                            dimension: -2,
                        },
                    ],
                },
            ],
        },
        {
            name: "dimensionlessRatio",
            symbol: ":",
            defaultUnit: {
                name: "one",
                symbol: "a:b",
            },
            baseQuantities: [
                {
                    name: "length",
                    dimension: 0,
                },
            ],
            units: [
                {
                    name: "probability",
                    symbol: "P(A)",
                    denominator: 1.0,
                },
                {
                    name: "percent",
                    symbol: "%",
                    denominator: 100.0,
                },
                {
                    name: "promille",
                    symbol: "‰",
                    denominator: 1000.0,
                },
                {
                    name: "percentOfAPercent",
                    symbol: "‱",
                    denominator: 10000.0,
                },
                {
                    name: "partsPerMillion",
                    symbol: "ppm",
                    denominator: 1000000.0,
                },
                {
                    name: "partsPerBillion",
                    symbol: "ppb",
                    denominator: 1000000000.0,
                },
                {
                    name: "bel",
                    symbol: "B",
                    prefix: "deci",
                    base: 10.0,
                    reference: 1.0,
                },
                {
                    name: "octa",
                    symbol: "octa",
                    denominator: 8.0,
                },
                {
                    name: "aqi_comeap_uk",
                    symbol: "",
                    denominator: 10.0,
                },
            ],
        },
        {
            name: "amountOfOdour",
            symbol: "OU",
            defaultUnit: {
                name: "europeanOdourUnit",
                symbol: "OUe",
            },
            baseQuantities: [
                {
                    name: "amountOfSubstance",
                    dimension: 0,
                },
            ],
        },
        {
            name: "odourConcentration",
            symbol: "C",
            defaultUnit: {
                name: "europeanOdourUnit_metre-3",
                symbol: "OUe·m⁻³",
            },
            baseQuantities: [
                {
                    name: "amountOfOdour",
                    dimension: 1,
                },
                {
                    name: "volume",
                    dimension: -1,
                },
            ],
            units: [
                {
                    prefix: "mega",
                    name: "europeanOdourUnit_metre-3",
                    symbol: "OUe·m⁻³",
                    baseUnits: [
                        {
                            name: "amountOfOdour.metric.mega.europeanOdourUnit",
                            dimension: 1,
                        },
                        {
                            name: "volume.metric.metre3",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
        {
            name: "3sOdourIntensity",
            symbol: "3S_OUI",
            defaultUnit: {
                name: "odourIntensityClass",
                symbol: "AU",
            },
            baseQuantities: [
                {
                    name: "amountOfSubstance",
                    dimension: 0,
                },
            ],
        },
        {
            name: "volumeFlow",
            symbol: "Q",
            baseQuantities: [
                {
                    name: "volume",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "metre3_hour-1",
                    baseUnits: [
                        {
                            name: "length.metric.metre",
                            dimension: 3,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
                {
                    name: "litre_second-1",
                    baseUnits: [
                        {
                            name: "volume.metric.litre",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.second",
                            dimension: -1,
                        },
                    ],
                },
                {
                    name: "litre_hour-1",
                    baseUnits: [
                        {
                            name: "volume.metric.litre",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
                {
                    system: "us",
                    name: "oilBarrel_hour-1",
                    baseUnits: [
                        {
                            name: "volume.us.oilBarrel",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.hour",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
        {
            name: "odourEmissionRate",
            symbol: "Q",
            defaultUnit: {
                name: "europeanOdourUnit_second-1",
                symbol: "OUe·s⁻¹",
            },
            baseQuantities: [
                {
                    name: "amountOfOdour",
                    dimension: 1,
                },
                {
                    name: "time",
                    dimension: -1,
                },
            ],
            units: [
                {
                    prefix: "mega",
                    name: "europeanOdourUnit_second-1",
                    symbol: "OUe·s⁻¹",
                    baseUnits: [
                        {
                            name: "amountOfOdour.metric.mega.europeanOdourUnit",
                            dimension: 1,
                        },
                        {
                            name: "time.metric.second",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
        {
            name: "massConcentration",
            symbol: "ρ",
            defaultUnit: {
                name: "kilogram_metre-3",
                symbol: "Kg·m⁻³",
            },
            baseQuantities: [
                {
                    name: "mass",
                    dimension: 1,
                },
                {
                    name: "volume",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "gram_metre-3",
                    symbol: "g·m⁻³",
                    baseUnits: [
                        {
                            name: "mass.metric.gram",
                            dimension: 1,
                        },
                        {
                            name: "volume.metric.metre3",
                            dimension: -1,
                        },
                    ],
                },
                {
                    name: "milligram_metre-3",
                    symbol: "mg·m⁻³",
                    baseUnits: [
                        {
                            name: "mass.metric.milli.gram",
                            dimension: 1,
                        },
                        {
                            name: "volume.metric.metre3",
                            dimension: -1,
                        },
                    ],
                },
                {
                    name: "microgram_metre-3",
                    symbol: "µg·m⁻³",
                    baseUnits: [
                        {
                            name: "mass.metric.micro.gram",
                            dimension: 1,
                        },
                        {
                            name: "volume.metric.metre3",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
        {
            name: "count",
            symbol: "N",
            defaultUnit: {
                name: "parts",
                symbol: "P",
            },
            baseQuantities: [
                {
                    name: "amountOfSubstance",
                    dimension: 0,
                },
            ],
        },
        {
            name: "particleConcentration",
            symbol: "C",
            defaultUnit: {
                name: "parts_metre-3",
                symbol: "P·m⁻³",
            },
            baseQuantities: [
                {
                    name: "count",
                    dimension: 1,
                },
                {
                    name: "volume",
                    dimension: -1,
                },
            ],
            units: [
                {
                    name: "parts_centimetre-3",
                    symbol: "P·cm⁻³",
                    baseUnits: [
                        {
                            name: "count.metric.parts",
                            dimension: 1,
                        },
                        {
                            name: "volume.metric.centi.metre3",
                            dimension: -1,
                        },
                    ],
                },
            ],
        },
    ],
};
